import 'custom-event-polyfill';
import 'string.prototype.padstart';
import 'whatwg-fetch';

import smoothscroll from 'smoothscroll-polyfill';
import replaceAll from 'string.prototype.replaceall';
import { getCrossOriginWorkerURL } from 'utils//threads';

smoothscroll.polyfill();
replaceAll.shim();

// Element.matches
(function (e) {
    const matches =
        e.matches ||
        e.matchesSelector ||
        e.webkitMatchesSelector ||
        e.mozMatchesSelector ||
        e.msMatchesSelector ||
        e.oMatchesSelector;
    !matches
        ? (e.matches = e.matchesSelector =
              function matches(selector) {
                  const matches = document.querySelectorAll(selector);
                  return Array.prototype.some.call(matches, (e) => {
                      return e === this;
                  });
              })
        : (e.matches = e.matchesSelector = matches);
})(Element.prototype);

// Element.toggleAttribute
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== void 0) force = !!force;

        if (this.hasAttribute(name)) {
            if (force) return true;

            this.removeAttribute(name);
            return false;
        }
        if (force === false) return false;

        this.setAttribute(name, '');
        return true;
    };
}

// HTMLCanvasElement.toBlob
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback: (blob: Blob) => void, type?: string, quality?: number) {
            const bin = atob(this.toDataURL(type, quality).split(',')[1]),
                len = bin.length,
                len32 = len >> 2,
                a8 = new Uint8Array(len),
                a32 = new Uint32Array(a8.buffer, 0, len32);

            let j = 0;
            for (let i = 0; i < len32; i++) {
                a32[i] =
                    bin.charCodeAt(j++) |
                    (bin.charCodeAt(j++) << 8) |
                    (bin.charCodeAt(j++) << 16) |
                    (bin.charCodeAt(j++) << 24);
            }

            let tailLength = len & 3;

            while (tailLength--) {
                a8[j] = bin.charCodeAt(j++);
            }

            callback(new Blob([a8], { type: type || 'image/png' }));
        },
    });
}

if (!globalThis.getCrossOriginWorkerURL) {
    globalThis.getCrossOriginWorkerURL = getCrossOriginWorkerURL;
}

if (!globalThis.ResizeObserver) {
    (async () => {
        try {
            const { default: ResizeObserver } = await import(
                /* webpackChunkName: "resize-observer-polyfill" */ 'resize-observer-polyfill'
            );
            globalThis.ResizeObserver = ResizeObserver;
        } catch {
            class ResizeObserverStub {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                observe(target: Element) {}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                unobserve(target: Element) {}
                disconnect() {}
            }
            globalThis.ResizeObserver = ResizeObserverStub;
        }
    })();
}

Function.prototype.toJSON = () => 'Unstorable function';

HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
